/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {},
  rules: [],
  tokens: {
    framedContainerBackgroundColor: '#fafafa',
    framedContainerBorderColor: '#e3e6e8',
    framedContainerBorderRadius: 4,
    framedContainerBorderWidth: 1,
    framedContainerPadding: 24,
    framedMaxHeight: 640,
    stackViewDividerColor: '#e3e6e8'
  }
}
export default theme
